module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAPFBMVEUAAAD/iwD/gAD/hwD/hQD/hQD/gAD/gAD/gQD/gAD/gQD/gAD/gAD/gAD/gAD/gAD/gAD/gAD/gAD///+6fvIdAAAAEnRSTlMACw4RFxkaIlVmfcHGx8zW2PuSPoK9AAAAAWJLR0QTDLtclgAAAG1JREFUSMft1tsKgCAQhOF1O6ed5v0ftqtuLcaEoPnvP1ZEcM2Uep47LZe1YSXAWV8AznoCAGwtORN7L1lNdpK15DFPmYaMvGmk5du04MAl12QWIvvwZWW/Z/lP8pqbqHUiRFaahZj4FYaW6pedqNYb8bEUX3EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow_left.png
// module id = 874
// module chunks = 0